import type { ReactElement } from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { DeskAudience } from './DeskAudience'
import { DeskArticles } from './DeskArticles'
import { DeskFlows } from './DeskFlows'
import { DeskIssues } from './DeskIssues'
import { DeskRevenue } from './DeskRevenue'
import { DeskSearch } from './DeskSearch'
import { DeskSources } from './DeskSources'
import { DeskTrends } from './DeskTrends'
import { DeskToday } from './DeskToday'
import { deskPath, isDeskTab } from '../../../lib/deskTabs'
import type { DeskTab } from '../../../lib/deskPeriod'

/** `visitors/desk/:pub/:tab`: every tab's screen. */
const SCREENS: Record<DeskTab, () => ReactElement> = {
  today: DeskToday,
  sources: DeskSources,
  search: DeskSearch,
  flows: DeskFlows,
  articles: DeskArticles,
  issues: DeskIssues,
  audience: DeskAudience,
  trends: DeskTrends,
  revenue: DeskRevenue,
}

export function DeskTabPage() {
  const { pub = '', tab } = useParams()
  const [sp] = useSearchParams()
  if (!isDeskTab(tab)) return <Navigate to={deskPath(pub || 'all', 'today', sp.toString())} replace />
  const Screen = SCREENS[tab]
  return <Screen />
}
